var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { set as setIn, toPoint } from '../../../..';
import { getDraftOffer } from '../../draft/offer/selectors';
import { getDraftPayment } from '../../draft/payment/selectors';
import { getDraftRequirements } from '../../draft/requirements/selectors';
import { getDraftRoute } from '../../draft/route/selectors';
import { getDraftTariff } from '../../draft/tariff/selectors';
import { getDraftCoupon } from '../../draft/coupon/selectors';
var extraDataMap = {
    floor: 'floor',
    contactPhone: 'contact_phone',
    comment: 'comment',
    apartment: 'apartment',
    doorCode: 'doorphone_number',
    porch: 'porch',
};
var toPairs = function (obj) { return Object.entries(obj); };
export var toRouteAddress = function (routePoint) {
    var address = routePoint.address, extraData = __rest(routePoint, ["address"]);
    var geoObject = address.geoObject;
    var extra = toPairs(extraData).reduce(function (acc, pair) {
        var _a;
        var name = pair[0], value = pair[1];
        var key = extraDataMap[name];
        if (value && key) {
            return __assign(__assign({}, acc), (_a = {}, _a[key] = value, _a));
        }
        return acc;
    }, undefined);
    return {
        fullname: geoObject.text,
        geopoint: toPoint(geoObject.pos),
        // не обязательные поля
        locality: geoObject.city,
        type: geoObject.type,
        uri: geoObject.uri,
        extra_data: extra,
        // @ts-ignore
        country: undefined,
    };
};
export var toDraftBody = function (state) {
    var offer = getDraftOffer(state);
    var route = getDraftRoute(state).map(toRouteAddress);
    var payment = getDraftPayment(state);
    var tariff = getDraftTariff(state);
    var requirements = getDraftRequirements(state);
    var coupon = getDraftCoupon(state);
    var body = {
        // дока https://github.yandex-team.ru/taxi/taximeter-emulator/blob/develop/README.md#параметры
        // 'search-0,wait-0,speed-200;'
        // comment: 'search-0,wait-0,speed-200;',
        offer: offer,
        route: route,
        requirements: coupon ? setIn(requirements, ['coupon'], coupon) : requirements,
        class: [tariff],
    };
    if (payment) {
        body.payment = {
            payment_method_id: payment.id,
            type: payment.type,
        };
    }
    return body;
};
export var toOrder = function (body, response) {
    var tariff = body.class[0];
    return {
        orderid: response.orderid,
        status: response.status,
        request: {
            class: tariff,
            route: body.route,
            requirements: body.requirements,
            comment: body.comment,
            due: body.due,
        },
        payment: body.payment,
        cancel_disabled: false,
        cost_message_details: {},
        userid: '',
    };
};
